// extracted by mini-css-extract-plugin
export default {"bestBanksBg":"best-banks-module--best-banks-bg--00eae"};